export const URLHelper = (() => {
  const buildUrl = (urlBase, params) => {
    urlBase = `${urlBase}?`;
    for (const param in params) {
      if (
        params[param] !== undefined &&
        params[param] !== null &&
        params[param] !== NaN
      ) {
        urlBase = urlBase + `${param}=${params[param]}&`;
      }
    }
    urlBase = urlBase.substring(0, urlBase.length - 1);
    return urlBase;
  };
  return { buildUrl };
})();
